import { useIsContractor } from "@/hooks/useIsContractor";
import type { ReactNode } from "react";
import { LoadingPanel } from "./LoadingPanel";
import { NotFoundPanel } from "./NotFoundPanel";

export function ContractorRoute({ children }: { children: ReactNode }) {
  const { isContractor, loading } = useIsContractor();
  if (loading) return <LoadingPanel />;
  if (!isContractor) return <NotFoundPanel />;
  return <>{children}</>;
}
